import { TableCell, TableRow } from '@mui/material';
import { FC, useContext } from 'react';
import { MarketItem } from '../../../../app/services/api/orderManagementClient';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { UserContext } from '../../../../components/shared/useUser';
import { isDemoModeEnabled } from '../../../../utils/featureAccess';
import { getGovernanceFlagForRow } from '../../../../mocks/data/catalogueGovernanceData';
import GovernanceStatusChip from '../../../../components/shared/catalogueGovernance/GovernanceStatusChip';

type Props = {
  item: MarketItem;
  index: number;
};

const ProductItemRow: FC<Props> = ({ item, index }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { hasPermissionTo } = useContext(UserContext);
  const isDemoMode = isDemoModeEnabled();
  const governanceFlag = isDemoMode ? getGovernanceFlagForRow(item.itemNumber, index) : undefined;

  const canEdit = hasPermissionTo(['ConfigurationAdmin']) || hasPermissionTo(['ProductUpdate']);

  const orderableUom = item.uoms?.find((uom) => uom.isOrderableUom);
  const orderableUomPrice = orderableUom?.price;

  const handleRowClick = () => {
    if (!canEdit) return;
    const params = new URLSearchParams();
    params.set('companyId', item.companyId.toString());
    if (item.customerTypeId !== undefined) {
      params.set('customerTypeId', item.customerTypeId.toString());
    }
    const searchTerm = searchParams.get('searchTerm');
    if (searchTerm) params.set('searchTerm', searchTerm);
    const sort = searchParams.get('sort');
    if (sort) params.set('sort', sort);
    const direction = searchParams.get('direction');
    if (direction) params.set('direction', direction);
    const page = searchParams.get('page');
    if (page) params.set('page', page);

    navigate(`/procurement/products/edit/${item.contentId}?${params.toString()}`);
  };

  return (
    <TableRow 
      onClick={canEdit ? handleRowClick : undefined}
      sx={{ 
        cursor: canEdit ? 'pointer' : 'default',
        '&:hover': canEdit ? {
          backgroundColor: 'action.hover',
        } : undefined,
      }}
    >
      <TableCell>
        {item.itemNumber}
      </TableCell>
      <TableCell>
        {item.itemName}
      </TableCell>
      <TableCell>
        {item.marketItemNumber || '-'}
      </TableCell>
      <TableCell>
        {item.primaryCategoryName || item.marketPrimaryCategoryName || '-'}
      </TableCell>
      <TableCell>
        {item.primaryUom}
      </TableCell>
      <TableCell>
        {item.orderableUom}
      </TableCell>
      <TableCell>
        {orderableUomPrice != null ? orderableUomPrice : '-'}
      </TableCell>
      <TableCell>
        {item.packSize || '-'}
      </TableCell>
      <TableCell>
        {item.caseSize || '-'}
      </TableCell>
      <TableCell>
        {item.innerPackSize || '-'}
      </TableCell>
      {isDemoMode && (
        <TableCell>
          <GovernanceStatusChip status={governanceFlag!.status} />
        </TableCell>
      )}
    </TableRow>
  );
};

export default ProductItemRow;
